import React, { useMemo } from 'react'

import { LayoutScroll } from 'components/LayoutPage'
import Empty from 'components/uiKit/Empty'
import { KitSize } from 'components/uiKit/KitTypes'
import { COMPANY_PATHS } from 'constants/paths'
import type { UsageBlockItem } from 'gql/__generated__/graphql'
import { usePathParams } from 'routes/hooks'
import { t } from 'services/Translation'

import FileUsage from './FileUsageComponent'
import * as s from './FileUsagesComponent.module.scss'
import { flattenUsage, groupUsage } from './helpers'

interface IFileUsageProps {
  fileUsages: UsageBlockItem[]
  projectId?: string
}

const FileUsagesComponent: React.FC<IFileUsageProps> = ({ fileUsages, projectId }) => {
  const { companyId } = usePathParams(COMPANY_PATHS.main)
  const groupedUsages = useMemo(() => groupUsage(fileUsages, companyId), [companyId, fileUsages])

  if (!fileUsages) {
    return null
  }

  if (!groupedUsages.length) {
    return <Empty size={KitSize.XS} text={t('entity.fileMeta.usage.emptyState')} grow />
  }

  return (
    <LayoutScroll sizeAutoCapable>
      <div className={s.group}>
        {groupedUsages.map((group) => (
          <div key={group.projectName}>
            {flattenUsage(group).map((usage, index) =>
              projectId && index === 0 ? null : (
                <FileUsage key={`${usage.name}-${index}`} usage={usage} />
              ),
            )}
          </div>
        ))}
      </div>
    </LayoutScroll>
  )
}

export default FileUsagesComponent
